import { defineStore } from 'pinia';
import fastapi from '@/lib/api';

export const useIssueStore = defineStore('issue', {
  state: () => ({
    issues: [],
    loading: false,
    error: null
  }),

  actions: {
    async searchIssues(searchParams) {
      this.loading = true;
      try {
        const response = await fastapi('post', '/issue/search', searchParams);
        if (response) {
          this.issues = response.items;
        }
        return response;
      } catch (error) {
        console.error('이슈 검색 중 오류 발생:', error);
        this.error = error.message || '이슈 검색 중 오류가 발생했습니다.';
        throw error;
      } finally {
        this.loading = false;
      }
    }
  }
}); 